import { Sede } from "./portale/sede";
export class PersonaGiuridicaDTO {
	codiceFiscale: string;
	partitaIVA: string;
	ragioneSociale: string;
	idPersonaGiuridica: string;
	codiceRegione: string;
	sedi: Array<Sede>;
	hasAmmUtenze: boolean;
}